import { AnalysisDemo, AnalysisDemoProps } from './AnalysisDemo';
import { BenefitsSection, BenefitsSectionProps } from './BenefitsSection';
import { BlogSection, BlogSectionProps } from './BlogSection';
import { CallToAction, CallToActionProps } from './CallToAction';
import { ColdReasons, ColdReasonsProps } from './ColdReasons';
import { FaqSection, FaqSectionProps } from './FaqSection';
import {
    FeatureExplanation,
    FeatureExplanationProps,
} from './FeatureExplanation';
import { FeatureSection, FeatureSectionProps } from './FeatureSection';
import {
    FeatureTestimonialSection,
    FeatureTestimonialSectionProps,
} from './FeatureTestimonialSection';
import { HeadlineProps, Headline } from './Headline';
import { HotReasons, HotReasonsProps } from './HotReasons';
import { MissionSection, MissionSectionProps } from './MissionSection';
import { NewsSection, NewsSectionProps } from './NewsSection';
import { Persona, PersonaProps } from './Persona';
import { PricingSection, PricingSectionProps } from './PricingSection';
import { PersonaHeader, PersonaHeaderProps } from './PersonaHeader';
import { PrivacySection, PrivacySectionProps } from './PrivacySection';
import { SocialValidation, SocialValidationProps } from './SocialValidation';
import {
    TestimonialSection,
    TestimonialSectionProps,
} from './TestimonialSection';
import { FeatureTableSection } from './FeatureTableSection';
import { VideoSection } from './VideoSection';
import { ReversableVideo } from './ReversableVideo';
import { TrainingContent } from './TrainingContent';
import { SimpleHeadlineProps, SimpleHeadline } from './SimpleHeadline';
import { LpBannerProps, LpBanner } from './LpBanner';

export default [
    AnalysisDemo,
    BenefitsSection,
    ColdReasons,
    FaqSection,
    FeatureExplanation,
    FeatureTableSection,
    FeatureTestimonialSection,
    HotReasons,
    LpBanner,
    MissionSection,
    PersonaHeader,
    PricingSection,
    VideoSection,
    ReversableVideo,
    TrainingContent,
    SimpleHeadline,
    BlogSection,
    CallToAction,
    FeatureSection,
    Headline,
    NewsSection,
    Persona,
    PrivacySection,
    SocialValidation,
    TestimonialSection,
];

export type Section =
    | AnalysisDemoProps
    | BenefitsSectionProps
    | BlogSectionProps
    | CallToActionProps
    | ColdReasonsProps
    | FaqSectionProps
    | FeatureExplanationProps
    | FeatureSectionProps
    | FeatureTestimonialSectionProps
    | HeadlineProps
    | HotReasonsProps
    | LpBannerProps
    | MissionSectionProps
    | NewsSectionProps
    | PersonaHeaderProps
    | PersonaProps
    | PricingSectionProps
    | PrivacySectionProps
    | SocialValidationProps
    | TestimonialSectionProps
    | SimpleHeadlineProps;

export * from './Footer';
export * from './Header';
